import { getComponentElements } from "../Base/utils.js";
import { isString, isArray } from "../utils/index.js";
function getTargetElements(nameOrSelectorOrElement, context) {
  if (isString(nameOrSelectorOrElement)) {
    return getComponentElements(nameOrSelectorOrElement, context);
  }
  if (!isArray(nameOrSelectorOrElement)) {
    return [nameOrSelectorOrElement];
  }
  return nameOrSelectorOrElement;
}
export {
  getTargetElements
};
//# sourceMappingURL=utils.js.map
